/*
 * Puts the caret in the first field, in reading order, that shows an error.
 * Found through the error line `Field` renders rather than `aria-invalid`, so
 * an injected picker that cannot carry the aria wiring is still reached, as
 * long as it took the id it was handed.
 */
export function focusFirstFieldError(form: HTMLFormElement): void {
  const error = form.querySelector<HTMLElement>('[data-slot="field-error"]');
  if (!error) return;

  const controlId = error.id.replace(/-error$/, '');
  const control = form.ownerDocument.getElementById(controlId);
  control?.focus();
}
